module.exports = __webpack_public_path__ + "static/Abap-d151d46dc67ee631341b408b2584170f.svg";